import React, { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import PageContainer from "~/components/PageContainer";
import { getData } from "~/functions/gridFunctions";
import { FullGridContext } from "../..";
import { findAccess } from "..";
import PagePreview from "./Preview";

export default function TicketLevels() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "name", asc: true };
  const defaultGridHeader = [
    { title: "Person", name: "name", type: "text", filter: false },
    { title: "E-mail", name: "email", type: "text", filter: false },
    { title: "Branch", name: "branch", type: "text", filter: false },
  ];

  const {
    accessModule,
    limit,
    opened,
    orderBy,
    page,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setLoadingData,
    setPages,
  } = useContext(FullGridContext);

  const pageAccess = findAccess(accessModule.children, "ticket-levels");

  useEffect(() => {
    setActiveFilters([]);
  }, []);

  async function loader() {
    setLoadingData(true);
    const data = await getData("tickets/levels", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });
    if (!data) {
      return;
    }
    setGridData(
      data.map(({ id, user, filial: branch }, index) => ({
        show: true,
        id,
        fields: [user?.name, user?.email, branch ? branch.name : "All branches"],
        page: Math.ceil((index + 1) / limit),
      }))
    );
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
    />
  );
}
